import styled from "styled-components";

export const ResumeStyles = styled.section`
    .small-title{
        padding-bottom: 3rem;
    }
    /* .u-small-title-margin{
        margin-top: 1rem;
    } */

    .Content{
        border-left: 2px solid var(--border-color);
    }
`;